import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-mono text-xs uppercase tracking-widest text-[#94A3B8]" data-testid="auth-loading">
          <span className="inline-block w-2 h-2 bg-[#FF5500] rounded-full animate-pulse-dot mr-2" />
          Authenticating...
        </div>
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" replace />;
  }
  return children;
};
